<template>
  <div class="jobs-form mt-5">
    <form @submit.prevent="updatejobs">

      <h3>Job Edit</h3>

      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control form-control-lg" v-model="name"/>
      </div>

      <div class="form-group">
        <label>Group name</label>
        <input type="text" class="form-control form-control-lg" v-model="groupname"/>
      </div>

      <div class="form-group">
        <label>Title</label>
        <input type="text" class="form-control form-control-lg" v-model="title"/>
      </div>
      <div class="form-group">
        <label>Schedule</label>
        <select class="form-control form-control-lg" v-model="frequency" v-if="frequency !== 'custom'">
          <option value="none">No recurring schedule</option>
          <option value="hourly">Every hour</option>
          <option value="daily">Every day at...</option>
        </select>
        <input v-else type="text" class="form-control form-control-lg" v-model="schedule"
               title="Custom cron expression, edit with care"/>
      </div>
      <div class="form-group" v-if="frequency === 'daily'">
        <label>Time of day</label>
        <input type="time" class="form-control form-control-lg" v-model="dailyTime"/>
      </div>
      <div class="form-group form-check" v-if="frequency !== 'none'">
        <input type="checkbox" class="form-check-input" id="schedulingEnabled" v-model="schedulingEnabled"/>
        <label class="form-check-label" for="schedulingEnabled">Enable scheduled runs</label>
      </div>
      <div class="form-group">
        <label>Type</label>
        <select class="form-control form-control-lg" v-model="type">
          <option value="crawl">crawl</option>
          <option value="monitor">monitor</option>
        </select>
      </div>
      <div class="form-group">
        <label>Tags</label>
        <input type="text" class="form-control form-control-lg" v-model="tags"/>
      </div>
      <div class="form-group">
        <label>Request delay (sec.)</label>
        <input type="text" class="form-control form-control-lg" v-model="request_delay"/>
      </div>
      <div class="form-group">
        <label>Config</label>
        <textarea type="password" class="form-control form-control-lg" v-model="config"/>
      </div>
      <div class="form-group">
        <label>Results</label>
        <textarea type="password" class="form-control form-control-lg" v-model="results" placeholder="null" disabled/>
      </div>

      <button type="submit" class="btn btn-dark btn-lg btn-block mt-2">Update</button>

    </form>
  </div>
</template>

<script>

import axios from "axios";
import statusCheck from "@/utils/statusCheck";
import tokenRefresh from "/src/utils/tokenRefresh.js";
import {buildCronExpression, parseCronExpression} from "/src/utils/schedule.js";


export default {
  name: 'jobs-list',
  data() {
    return {
      name: '',
      groupname: '',
      title: '',
      type: 'crawl',
      schedule: '',
      frequency: 'none',
      dailyTime: '00:00',
      schedulingEnabled: false,
      status: '',
      tags: '',
      config: '',
      results: '',
      request_delay: '',
    }
  },
  mounted() {
    let jobId = window.location.pathname.split("/").pop();
    axios.get(process.env.VUE_APP_CRAWLING_URL + '/api/jobs/' + jobId)
        .then((response) => {
              this.name = response.data["name"];
              this.groupname = response.data["group_name"];
              this.title = response.data["title"];
              this.schedule = response.data["schedule"];
              const parsed = parseCronExpression(response.data["schedule"]);
              this.frequency = parsed.frequency;
              this.dailyTime = parsed.time;
              this.schedulingEnabled = !!response.data["scheduling_enabled"];
              this.type = response.data["type"] || 'crawl';
              this.tags = Array.isArray(response.data["tags"]) ? response.data["tags"].join(', ') : (response.data["tags"] || '');
              this.config = atob(response.data["config"]);
              this.results = response.data["results"];
              this.request_delay = response.data["request_delay"];
            }
        )
        .catch(function (error) {
              statusCheck(error.response.status);
            }
        )
  },
  methods: {
    updatejobs: function () {
      let jobId = window.location.pathname.split("/").pop();
      const {name, groupname, title, type, tags, config, frequency, dailyTime, schedulingEnabled, request_delay} = this;
      let encodeConfig = btoa(config);
      const tagsArray = tags ? tags.split(',').map(t => t.trim()).filter(t => t) : [];
      const schedule = frequency === 'custom' ? this.schedule : buildCronExpression(frequency, dailyTime);
      axios.put(process.env.VUE_APP_CRAWLING_URL + '/api/jobs/' + jobId,
          {
            "name": name,
            "group_name": groupname,
            "title": title,
            "type": type,
            "tags": tagsArray,
            "config": encodeConfig,
            "schedule": schedule,
            "scheduling_enabled": frequency !== 'none' && schedulingEnabled,
            "request_delay": request_delay
          }
      )
          .then((response) => {
                if (response.status === 200) {
                  tokenRefresh()
                  this.$router.push({name: "jobs"});
                }
              }
          )
          .catch(function (error) {
                statusCheck(error.response.status);
              }
          )
    }
  }
};
</script>